import { money } from '../../lib/money';
import { cn } from '../../lib/cn';

export interface MoneyProps {
  value: number | null | undefined;
  /** Round to whole dollars — summary tiles and axis labels only. */
  whole?: boolean;
  /** Always show a leading + on positive amounts (flow deltas). */
  signed?: boolean;
  /**
   * 'auto' colors negatives danger; positives stay ink — NEVER green.
   * 'none' (default) renders everything in the inherited ink.
   */
  tone?: 'auto' | 'none';
  className?: string;
}

/**
 * The one way an amount reaches the screen: money() from lib/money.ts
 * (U+2212 minus, pinned 2 decimals) in a tabular right-aligned span.
 */
export default function Money({ value, whole, signed, tone = 'none', className }: MoneyProps) {
  const negative = typeof value === 'number' && value < 0;
  return (
    <span className={cn('t-num whitespace-nowrap', tone === 'auto' && negative && 'text-danger', className)}>
      {money(value, { whole, signed })}
    </span>
  );
}
